// Marca de fábrica: se usa solo cuando la empresa no configuró su propio
// logo / nombre en Configuración → Whitelabel.
//
// - Instalaciones nuevas: marca CloudPeruCRM.
// - Instalaciones que ya existían antes de la v7.6.0 ("legacy"): conservan
//   los valores de fábrica de siempre, para que una actualización no cambie
//   su apariencia. El backend lo indica con el ajuste público
//   "brandingDefaults" = "legacy" (lo crea una migración solo en updates).
import brandLogoLight from "../assets/logo1.png";
import brandLogoDark from "../assets/logo2.png";
import legacyLogoLight from "../assets/logo-legacy-light.png";
import legacyLogoDark from "../assets/logo-legacy-dark.png";

const STORAGE_KEY = "wl_brandingLegacy";

const BRAND = {
  logoLight: brandLogoLight,
  logoDark: brandLogoDark,
  favicon: "/cloudperucrm-icon-192.png",
  pwaIcon: "/cloudperucrm-icon-512.png",
  name: "CloudPeruCRM"
};

const LEGACY = {
  logoLight: legacyLogoLight,
  logoDark: legacyLogoDark,
  favicon: "/favicon.ico",
  pwaIcon: null, // el manifest estático ya trae sus íconos
  name: "Equipechat"
};

export const isLegacyBranding = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) === "true";
  } catch {
    return false;
  }
};

export const rememberLegacyBranding = legacy => {
  try {
    localStorage.setItem(STORAGE_KEY, legacy ? "true" : "false");
  } catch {}
};

export const brandDefaults = (legacy = isLegacyBranding()) =>
  legacy ? LEGACY : BRAND;

// Cualquiera de los logos de fábrica (para saber si hay uno personalizado)
export const isDefaultLogo = url =>
  [brandLogoLight, brandLogoDark, legacyLogoLight, legacyLogoDark].includes(url);
